export const flannel = [
  {
    number: 'FL99',
    hasModel: true,
  },
  {
    number: 'FL100',
    hasModel: false,
  },
  {
    number: 'FL101',
    hasModel: false,
  },
  {
    number: 'FL102',
    hasModel: false,
  },
  {
    number: 'FL103',
    hasModel: false,
  },
  {
    number: 'FL104',
    hasModel: false,
  },
  {
    number: 'FL105',
    hasModel: true,
  },
  {
    number: 'FL106',
    hasModel: false,
  },
  {
    number: 'FL107',
    hasModel: false,
  },
  {
    number: 'FL108',
    hasModel: true,
  },
  {
    number: 'FL109',
    hasModel: false,
  },
  {
    number: 'FL110',
    hasModel: false,
  },
  {
    number: 'FL111',
    hasModel: true,
  },
  {
    number: 'FL112',
    hasModel: false,
  },
  {
    number: 'FL113',
    hasModel: false,
  },
  {
    number: 'FL114',
    hasModel: false,
  },
  {
    number: 'FL115',
    hasModel: false,
  },
  {
    number: 'FL116',
    hasModel: false,
  },
  {
    number: 'FL117',
    hasModel: true,
  },
  {
    number: 'FL118',
    hasModel: false,
  },
  {
    number: 'FL119',
    hasModel: false,
  },
  {
    number: 'FL120',
    hasModel: false,
  },
  {
    number: 'FL121',
    hasModel: false,
  },
  {
    number: 'FLX',
    hasModel: false,
  },
];
